import { store } from '@/state/store';
import { UTILS__graph_ui } from '@/utils/UTILS__graph_ui';
import { DTO_GRAPH__instance } from '@shared/dto/generation/graph_invoke/_graph/DTO_GRAPH__instance';
import { Node, NodeChange } from '@xyflow/react';

export function FN_GRAPH_UPDATE__node_remove__by_change(change: NodeChange<Node>, graph: DTO_GRAPH__instance) {
  if (change.type !== 'remove') return false;

  let node_id = change.id;

  graph.node__delete(node_id);

  if (store.getState().slice_ui.g_graph__node_id_selected == node_id) UTILS__graph_ui.node__deselect();

  return true; //need to update graph remotely
}
